import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import React, { type SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { KYCStatus } from '~/api/KYCStatus';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import type { IconTypes } from '~/components/Icon/IconTypes';
import { userStore } from '~/stores';
import { PROMOCODES_PAGE_URL } from './constants';
import styles from './PromocodesMenuItem.module.scss';

export interface PromocodesMenuItemProps
  extends React.PropsWithChildren<
    Omit<React.ComponentProps<typeof Link>, 'to'>
  > {
  className?: string;
  labelClassName?: string;
  label?: string;
  link?: string;
  hideIcon?: boolean;
  icon?: IconTypes;
  iconSize?: number;
  onClick?: (e: SyntheticEvent) => void;
}

const PromocodesMenuItem: React.FC<PromocodesMenuItemProps> = ({
  className,
  labelClassName,
  children,
  onClick,
  link = PROMOCODES_PAGE_URL,
  icon = 'promocodes',
  iconSize = 24,
  hideIcon = false,
  ...props
}) => {
  const { t } = useTranslation();

  const { label = t('promocodes'), ...rest } = props;

  if (
    company.needKycCheck &&
    userStore.personalData?.kycStatus !== KYCStatus.Verified
  ) {
    return null;
  }

  return (
    <Link
      {...rest}
      to={link}
      className={classes([styles.root, className])}
      onClick={onClick}
    >
      {!hideIcon && <Icon type={icon} size={iconSize} />}
      <p className={classes([styles.label, labelClassName])}>{label}</p>
      {children}
    </Link>
  );
};

export default observer(PromocodesMenuItem);
